import React from "react";
import { useNavigate } from "react-router";
import { connect } from "react-redux";
import { fetchApi } from "../../Utils/Connections";

const mapStateToProps = (state: any) => {
  return {
    admin: state.admin,
    path: state.path,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setAdmin: (admin: any) => dispatch({ type: "SET_ADMIN", payload: admin }),
    setPath: (path: string) => dispatch({ type: "SET_PATH", payload: path }),
    setToken: (token: string) => dispatch({ type: "SET_TOKEN", payload: token }),
  };
};

const Admin = ({ admin, setAdmin, path, setPath, setToken }: any) => {
  const navigate = useNavigate();
  const [username, setUsername] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");

  const Login = async () => {
    if (!username.trim() || !password) {
      setError("Please enter your username and password.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const result = await fetchApi(`Admin/Login`, "POST", {
        UserName: username.trim(),
        Password: password,
      });
      const jwt = result?.My_Result?.JWT_TOKEN;
      if (result.StatusCode === 200 && jwt) {
        sessionStorage.setItem("token", jwt);
        // Navigation's guard reads the Redux token; without this it redirects back to /admin
        setToken(jwt);
        setAdmin(true);
        setPath("/admin/dashboard");
        navigate("/admin/dashboard");
      } else {
        // ExceptionMsg can be a raw database error, so it is logged rather than shown
        console.warn("Admin login rejected", result?.StatusCode, result?.ExceptionMsg);
        setError("Invalid username or password.");
      }
    } catch (e) {
      console.warn("Admin login failed", e);
      setError("Could not reach the server. Check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="adminLogin d-flex align-items-center justify-content-center">
        <div
          className="card shadow border-0 p-3 text-center"
          style={{ width: "30rem", maxWidth: "95%" }}>
          <h3>ICDR - ISCDR Admin </h3>
          <div>
            <div>
              <input
                type="text"
                className="form-control rounded"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="d-flex align-items-center mt-2">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control  rounded"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={`bi bi-${!showPassword ? "eye" : "eye-slash"}`}
                onClick={() => setShowPassword(!showPassword)}
                style={{ marginLeft: "-2rem", padding: "0.5rem" }}
              />
            </div>
          </div>

          {error && (
            <div className="text-danger mt-2" role="alert">
              {error}
            </div>
          )}

          <button
            className="btn btn-primary btn-block rounded mt-2"
            onClick={Login}
            disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
